import {connect} from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import {getSubmitFormSuccessStatus} from "../../../reducers/common/submitForm";
import AddAssistantComponent from "./AddAssistantComponent";
import {
    getContinentsData, getCountriesData, getCurrentContinent,
    setCurrentContinent
} from "../../../reducers/common/location";
import {onCreateAssistant} from "../../../reducers/assistant/assistants";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        success: getSubmitFormSuccessStatus(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onProcess: (data) => {
            dispatch(onCreateAssistant(data));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AddAssistantComponent);



// WEBPACK FOOTER //
// ./src/components/assistantsManagement/addAssistantComponent/AddAssistantComponent.container.js